import "../../scss/app.scss";
import "../../vendor/globals.js"; // NEED to set first: set window.$, window._, ...
import { _, $, Backbone, sha1 } from "../../vendor";
import InboomaBaseView from "../views/InboomaBaseView";
import { getUrlParameter } from "../utils/Uri";
import * as Sync from "../Sync";
import Inboomai18n from "../utils/Inboomai18n";

let client_id = false;
let language =
  typeof getUrlParameter("lang") !== "undefined"
    ? getUrlParameter("lang")
    : "de_DE";
$(document).ready(function () {
  const hash = getUrlParameter("hash");

  if (typeof hash != "undefined") {
    var hash_length = hash.length - 40; // extract length of client_id
    var pre_hash = btoa(
      parseInt(hash.substr(0, hash_length)) * 7532 +
        parseInt(hash.substr(0, hash_length)),
    );
    var verify_hash = sha1(pre_hash);

    if (verify_hash == hash.substring(hash_length)) {
      client_id = parseInt(hash.substring(0, hash_length));
    }

    if (client_id) {
      $(".js-off-canvas-overlay").removeClass("is-visible");

      /*  const ClientLogoRequest = Backbone.Model.extend({
                urlRoot: '/client_logos?client_id=' + client_id
            });

            const clientLogoRequest = (new ClientLogoRequest()).fetch({
                success: (model, response) => {

                    let logo = '';
                    // @todo store in cookies or localStorage

                    _.each(response.data, (_logo, key) => {
                        if (_logo.type == 'main') {
                            logo = _logo.logo;
                        }
                    });
                    i

                    const PrivacyView = (language.substring(0,2) === "en" ? InboomaBaseView.extend({

                        template: _.template($('#inb-privacy-booking-en-tpl').html()),
                        el: '#inb-c-main',

                    }): InboomaBaseView.extend({

                        template: $('#inb-privacy-booking-tpl').html(),
                        el: '#inb-c-main',

                    }));

                    const privacyView = (new PrivacyView()).render();
                    $("#inb-c-client--logo").attr('src', logo);

                }
            });*/

      const ClientRequest = Backbone.Model.extend({
        urlRoot: "/clients/" + client_id,
      });

      const clientRequest = new ClientRequest().fetch({
        success: (model, response) => {
          var client = response.data;
          if (client.client_settings[0].system_operator) {
            $("#NameOrOrganization").html(client.organization);
            $("#StreetAndHnr").html(client.street + " " + client.number);
            $("#CountryShortAndPlzAndCity").html(
              client.country + "-" + client.zip + ", " + client.city,
            );
            $("#own").removeClass("hide");
          } else {
            $("#own1").removeClass("hide");
          }
          var PrivacyView = InboomaBaseView.extend({
            template: _.template($("#inb-privacy-booking-tpl").html()),
            el: "#inb-c-main",
          });

          const privacyView = new PrivacyView().render();
          $("#inb-c-client--logo").attr("src", client.logo);
        },
      });
    } else {
      $("#ErrorMessage").html("Invalid Hash");
      $("#inb-c-main").html("");
    }
  } else {
    $("#ErrorMessage").html("Client ID required");
    $("#inb-c-main").html("");
  }
});
